import React from 'react'
import './App.css';
import { Link } from 'react-router-dom';

export default function HomeScreen() {
  return (
    <div className="home-screen">
      <div className="main-card">
        <div className="logo-placeholder">
          <img src="/Logo.png" alt="Arrow Puzzle Logo" className="logo-image" />
        </div>
        <h1>Arrow Puzzle - Puzzle Escape Games</h1>
        <p>Welcome to Arrow Puzzle - Puzzle Escape Games</p>
        <Link to="/privacy_policy" className="main-button">
          Privacy Policy
        </Link>
      </div>
    </div>
  )
}

